import Container from "./Container";
import Image from "../components/Image";
import loader from "../assets/images/wings_loader.gif";

export default function CardLoader() {
    return (
        <Container flexColumn center className="my-progress-spinner w-full p-8">
            <div className="flex flex-wrap align-items-center justify-content-center">
                <Image src={loader} width={80} />
            </div>
        </Container>
    )
}
